import { AxiosPromise } from 'axios';
import { ApiProfile } from '../../api/auth';
import { ApiPaginatedResponse, request } from '../../api';

export interface ApiPostFile {
    id: number,
    name: string,
    type: 'image' | 'video' | 'document',
    file?: File,
    preview?: any,
    url?: string,
}

export interface ApiPost {
    id: number,
    type: 1 | 2,
    parentId?: number,
    content: string,
    html: string,
    createdBy: ApiProfile,
    files: ApiPostFile[],
    createdAt: string,
    children?: ApiPost[],
    options?: {
        mentions?: {
            id: string,
            name: string,
            replace: string[],
            perma: string,
        }[],
        youtube?: string,
        vimeo?: string,
        type?: string,
        id?: number,
        name?: string,
        date?: string,
    },
}

export const rest = {
    getList: (page: number, profileId?: number): AxiosPromise<ApiPaginatedResponse<ApiPost[]>> => {
        return request.get(`timeline${profileId ? `/${profileId}` : ''}?page=${page}`);
    },
    store: (
        content: string,
        files: Partial<ApiPostFile>[] = [],
        profileId?: number,
        parentId?: number,
    ): AxiosPromise<{ data: ApiPost }> => {
        const data = new FormData();
        data.append('profile_id', `${profileId || ''}`);
        data.append('parent_id', `${parentId || ''}`);
        data.append('content', content);
        data.append('files', `${files.length}`);
        files?.forEach((file, index) => {
            data.append(`file-${index}`, file.file as File);
        });

        return request.post('timeline', data);
    },
    update: (
        post: ApiPost,
        content: string,
        files: Partial<ApiPostFile>[] = [],
    ): AxiosPromise<{ data: ApiPost }> => {
        const data = new FormData();
        data.append('content', content);
        data.append('documents', post.files.map((o) => o.id).join(','));
        data.append('files', `${files.length}`);
        files?.forEach((file, index) => {
            data.append(`file-${index}`, file.file as File);
        });

        return request.post(`timeline/${post.id}/update`, data);
    }
}

export default rest;
